import React from 'react';
import { Link } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';
import OracleCardPreview from './OracleCardPreview';

const LinktreeButton = ({ item, index, onButtonClick }) => {
  const { ref, inView } = useInView({ threshold: 0.1, triggerOnce: true });
  const isFeatured = item.featured;
  
  // Soporta tanto la tirada en cruz (+) como en X
  const isCustomCross = item.layout === 'cross' || item.layout === 'cross-x';

  const linkBaseClasses = `group relative w-full max-w-md mx-auto mb-4 flex items-center justify-center rounded-xl text-white font-medium transition-all duration-300 ease-in-out ${
    inView ? "animate-fade-in" : "opacity-0 translate-y-4"
  } border border-gray-700 shadow-md shadow-gray-700/30`;

  const contentDivClasses = `relative w-full flex items-center rounded-xl transition-colors duration-300 ${
    isFeatured ? 'flex-col py-4 px-5 bg-black/50 hover:bg-black/70' : 'flex-row py-3 px-4 bg-black/30 hover:bg-gray-800'
  }`;

  return (
    <Link 
      to={item.path} 
      ref={ref} 
      className={linkBaseClasses} 
      style={{ animationDelay: `${index * 100}ms` }} 
      onClick={() => onButtonClick && onButtonClick(item.title, item.path)}
    >
      <div className={contentDivClasses}>
        
        {/* Contenedor de cartas / icono */}
        <div className={`flex-shrink-0 flex items-center justify-center ${
          isFeatured 
            ? (isCustomCross ? 'w-40 h-44 mb-3' : 'w-40 h-40 mb-4') 
            : 'w-10 h-10 mr-4'
        }`}>
          <OracleCardPreview item={item} />
        </div>

        {/* Título y subtítulo */}
        <div className="flex-1 flex flex-col items-center justify-center text-center z-10">
          {item.title && (
            <span className={`font-semibold text-base sm:text-lg ${isFeatured ? 'mt-2' : ''} group-hover:text-white transition-colors`}>
              {item.title}
            </span>
          )}
          {item.subtitle && (
            <span className={`text-sm text-gray-400 mt-1 ${isFeatured ? 'text-base' : ''} group-hover:text-gray-300 transition-colors`}>
              {item.subtitle}
            </span>
          )}
        </div>

        {/* Espaciador para vista no destacada */}
        {!isFeatured && (item.image || item.cardCount) && (
          <div className="w-10 h-10" aria-hidden="true"></div>
        )}
      </div>
    </Link>
  );
};

export default LinktreeButton;